import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from "@/common/helper";
import navbarStore from '@/store/navbar';
import { isStringEmpty } from '@shared/utils';
import wsStore from '../store';
import { useMemo } from 'react';
import { getFixedRenewData } from '@shared/store/chat';
import "./UserMessage.scss";
import { ALL_FILE_ICONS, FILE_ICONS } from '@/components/input-file/shared';
import { formatFileSize } from '@shared/utils/file';
import globalStore from '@/store/global';

const UserMessage = observer((props) => {
  const store = wsStore.currentStore;
  const {
    msg_id,
    role_id,
    prompt: question,
    page = [],
    txt,
    compare_parent_id,
    role_biz,
    file,
    status,
  } = props;

  const llmInfo = navbarStore.chatModels[role_id] || {};
  const pageInfo = useMemo(() => {
    const { page } = getFixedRenewData(props);
    if(!page){
      return null;
    }
    return page[0];
  }, [page]);
  const fileInfo = useMemo(() => {
    return file?.[0];
  }, [file]);

  return (
    <div>
      {
        compare_parent_id
        ? (
          <section className="flex justify-end items-center text-[12px] leading-[17px] text-black mt-[12px]">
            <div className="opacity-50">您请求</div>
            <div className="font-bold mx-[4px] opacity-90">@{llmInfo?.title || ''}</div>
            <div className="opacity-50">再次回复</div>
          </section>
        )
        : (
          <>
            {
              status == -1
              ? null
              : [
                "summary_page",
                "page",
              ].includes(role_biz) && pageInfo?.title
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-16px">
                  <a
                    className="block px-[16px] py-[8px] hover:bg-secondary rounded-[16px] cursor-pointer text-[12px] !text-primary !text-opacity-40"
                    onClick={
                      () => {
                        store.log({
                          action : "click",
                          arrt : "aibot_plugin_sidebar_summaryweb_info",
                          ext : pageInfo.title,
                          ext1 : pageInfo.url,
                          message_id : msg_id,
                          role_id,
                        });
                        HelperCore.openPage(pageInfo.url);
                      }
                    }
                  >
                    <div 
                      className="user-referer-link w-auto max-w-[240px] line-clamp-4 border-l-[4px] border-black-6 pl-[16px] text-[15px] leading-[24px]"
                      onCopy={HelperCore.handleTrimCopy}>
                      {(pageInfo.title || "").slice(0, 200)}
                    </div>
                  </a>
                </section>
              )
              : [
                "explain",
                "translation",
              ].includes(role_biz) && txt?.content
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-16px">
                  <span
                    className="block px-[16px] py-[8px] hover:bg-secondary rounded-[16px] text-[12px] !text-primary !text-opacity-40"
                  >
                    <div 
                      className="w-auto max-w-[240px] border-l-[4px] border-black-6 pl-[16px] text-[15px] leading-[24px] whitespace-pre-wrap break-all"
                      onCopy={HelperCore.handleTrimCopy}>
                      {txt.content.slice(0, 200)}
                    </div>
                  </span>
                </section>
              )
              : [
                "chat_image",
                "extract_image",
                "explain_image",
              ].includes(role_biz) && fileInfo?.url
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-[8px]">
                  <img src={fileInfo.url} className='max-w-[200px] max-h-[200px] rounded-[16px] border-[1px] border-solid border-black border-opacity-5' />
                </section>
              )
              : [
                "doc",
              ].includes(role_biz) && fileInfo?.ext && ALL_FILE_ICONS[fileInfo.ext]
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-[8px]">
                  <div className={[
                    "flex items-center border-[1px] border-solid p-[8px] rounded-[16px]",
                    globalStore.isDark ? 'border-white border-opacity-30' : 'border-black border-opacity-10'
                  ]}>
                    <img src={ ALL_FILE_ICONS[fileInfo.ext]} className='size-32px mr-[8px]' />
                    <div className="max-w-[270px]">
                      <div className="text-[12px] leading-[16px] font-bold text-primary-opacity text-opacity-80 truncate">
                        {fileInfo.title}
                      </div>
                      <div className="text-[12px] leading-[16px] text-primary-opacity text-opacity-50">
                        {formatFileSize(fileInfo.size)}
                      </div>
                    </div>
                  </div>
                </section>
              )
              : null
            }
            {
              !isStringEmpty(question) && (
                <section className="flex justify-end">
                  <p
                    // style={{
                    //   background:
                    //     'linear-gradient( 220deg, #1465FF 0%, #9A14FF 100%)',
                    // }}
                    onCopy={HelperCore.handleTrimCopy}
                    className={[
                      'max-w-[80%] bg-[#2780FE]',
                      'rounded-[16px]',
                      'px-[16px] py-[10px]',
                      'text-white text-[15px] leading-[22px]',
                      'whitespace-pre-line break-all overflow-x-hidden',
                    ]}
                  >
                    {question}
                  </p>
                </section>
              )
            }
          </>
        )
      }
    </div>
  )
});
export default UserMessage;